import { conditionControlCode } from "js/includes/editors/Policy/PolicyEditor/tabs/Conditions/defaults"
import { localizedF, localized } from "js/includes/common/utils"
import { forEach } from "ramda"

const hostConditionOptions = {
  nullValue: conditionControlCode.SelectCondition,
  requiredMessage: localizedF("editors.policy.conditions.conditionRequired"),
  value: conditionControlCode.SelectCondition,
  items: [
    {
      value: conditionControlCode.SelectCondition,
      text: localizedF("editors.policy.conditions.selectCondition"),
    },
    {
      value: conditionControlCode.CPU,
      text: localizedF("editors.policy.conditions.aggregateCpuUsage"),
    },
    {
      value: conditionControlCode.DiskUsage,
      text: localizedF("editors.policy.conditions.diskUsage"),
    },
    {
      value: conditionControlCode.DataStoreFreeSpace,
      text: localizedF("editors.policy.conditions.dataStoreFreeSpace"),
    },
    {
      value: conditionControlCode.VMHostUptime,
      text: localizedF("editors.policy.conditions.vmHostUpTime"),
    },
    {
      value: conditionControlCode.DeviceDown,
      text: localizedF("editors.policy.conditions.deviceDown"),
    },
  ],
}

export const vmWareHostConditionOptions = {
  ...hostConditionOptions,
  items: [
    ...hostConditionOptions.items,
    {
      value: conditionControlCode.Memory,
      text: localizedF("editors.policy.conditions.memoryUsage"),
    },
    {
      value: conditionControlCode.BadSensorCount,
      text: localizedF("editors.policy.conditions.badSensorCount"),
    },
    {
      value: conditionControlCode.SensorHealth,
      text: localizedF("editors.policy.conditions.sensorHealth"),
    },
  ],
}

export const hyperVHostConditionOptions = hostConditionOptions

const vmConditionOptions = {
  nullValue: conditionControlCode.SelectCondition,
  requiredMessage: localizedF("editors.policy.conditions.conditionRequired"),
  value: conditionControlCode.SelectCondition,
  items: [
    {
      value: conditionControlCode.SelectCondition,
      text: localizedF("editors.policy.conditions.selectCondition"),
    },
    {
      value: conditionControlCode.ProcessorUsage,
      text: localizedF("editors.policy.conditions.processorUsage"),
    },
    {
      value: conditionControlCode.GuestOperationMode,
      text: localizedF("editors.policy.conditions.guestOperationMode"),
    },
    {
      value: conditionControlCode.GuestToolsNotRunning,
      text: localizedF("editors.policy.conditions.guestToolsNotRunning"),
    },
  ],
}

export const vmVMWareConditionOptions = {
  ...vmConditionOptions,
  items: [
    ...vmConditionOptions.items,
    {
      value: conditionControlCode.Memory,
      text: localizedF("general.memory"),
    },
    {
      value: conditionControlCode.SnapshotSize,
      text: localizedF("editors.policy.conditions.snapshotSize"),
    },
    {
      value: conditionControlCode.SnapshotLifeSpan,
      text: localizedF("editors.policy.conditions.snapshotLifeSpan"),
    },
  ],
}

export const vmHyperVConditionOptions = {
  ...vmConditionOptions,
  items: [
    ...vmConditionOptions.items,
    {
      value: conditionControlCode.CheckpointSize,
      text: localizedF("editors.policy.conditions.checkpointSize"),
    },
    {
      value: conditionControlCode.CheckpointLifeSpan,
      text: localizedF("editors.policy.conditions.checkpointLifeSpan"),
    },
  ],
}

export const operatorOptions = {
  value: "GE",
  items: [
    { value: "GE", text: localizedF("editors.policy.conditions.greaterThanOrEqual") },
    { value: "LE", text: localizedF("editors.policy.conditions.lessThanOrEqual") },
    { value: "LT", text: localizedF("editors.policy.conditions.lessThan") },
    { value: "GT", text: localizedF("editors.policy.conditions.greaterThan") },
    { value: "EQ", text: localizedF("editors.policy.conditions.equalTo") },
    { value: "NE", text: localizedF("editors.policy.conditions.notEqualTo") },
  ],
}

export const operatorOptionsKeys = {
  GE: localizedF("editors.policy.conditions.greaterThanOrEqual"),
  LE: localizedF("editors.policy.conditions.lessThanOrEqual"),
  LT: localizedF("editors.policy.conditions.lessThan"),
  GT: localizedF("editors.policy.conditions.greaterThan"),
  EQ: localizedF("editors.policy.conditions.equalTo"),
  NE: localizedF("editors.policy.conditions.notEqualTo"),
}

export const durationOptions = {
  value: 5,
  items: [
    { value: 5, text: () => "5 " + localized("general.minutes").toLowerCase() },
    { value: 15, text: () => "15 " + localized("general.minutes").toLowerCase() },
    { value: 30, text: () => "30 " + localized("general.minutes").toLowerCase() },
    { value: 60, text: () => "60 " + localized("general.minutes").toLowerCase() },
  ],
}

export const severityOptions = {
  value: null,
  items: [
    { value: "CRITICAL", text: localizedF("general.critical") },
    { value: "MAJOR", text: localizedF("general.major") },
    { value: "MODERATE", text: localizedF("general.moderate") },
    { value: "MINOR", text: localizedF("general.minor") },
    { value: null, text: localizedF("general.none") },
  ],
}

export const priorityOptions = {
  value: null,
  items: [
    { value: "HIGH", text: localizedF("general.high") },
    { value: "MEDIUM", text: localizedF("general.medium") },
    { value: "LOW", text: localizedF("general.low") },
    { value: null, text: localizedF("general.none") },
  ],
}

export const unitOptions = {
  value: "PERCENT",
  items: [
    { value: "PERCENT", text: "%" },
    { value: "BYTES", text: localizedF("editors.policy.conditions.byte") },
  ],
}

export const unitOptionsDWM = {
  value: "DAY",
  items: [
    { value: "DAY", text: localizedF("general.days") },
    { value: "WEEK", text: localizedF("general.weeks") },
    { value: "MONTH", text: localizedF("general.months") },
  ],
}

export const unitBytesOptions = {
  value: "GB",
  items: [
    { value: "KB", text: "Kilo" },
    { value: "MB", text: "Mega" },
    { value: "GB", text: "Giga" },
    { value: "TB", text: "Tera" },
  ],
}

export const unitBpsOptions = {
  value: "GB",
  items: [
    { value: "KB", text: "KiBps" },
    { value: "MB", text: "MiBps" },
    { value: "GB", text: "GiBps" },
    { value: "TB", text: "TiBps" },
  ],
}

export const unitBpsOptionsKeys = {
  KB: "KiBps",
  MB: "MiBps",
  GB: "GiBps",
  TB: "TiBps",
}

export const byteOptions = {
  value: "OUT_BYTES",
  items: [
    { value: "IN_BYTES", text: localizedF("editors.policy.conditions.inBytes") },
    { value: "OUT_BYTES", text: localizedF("editors.policy.conditions.outBytes") },
    { value: "IO_BYTES", text: localizedF("editors.policy.conditions.inOutBytes") },
  ],
}

export const byteOptionsKeys = {
  IN_BYTES: localizedF("editors.policy.conditions.inBytes"),
  OUT_BYTES: localizedF("editors.policy.conditions.outBytes"),
  IO_BYTES: localizedF("editors.policy.conditions.inOutBytes"),
}

export const rWOptions = {
  value: "OUT_BYTES",
  items: [
    { value: "IN_BYTES", text: localizedF("editors.policy.conditions.readSpeed") },
    { value: "OUT_BYTES", text: localizedF("editors.policy.conditions.writeSpeed") },
    { value: "IO_BYTES", text: localizedF("editors.policy.conditions.readWriteSpeed") },
  ],
}

export const rwOptionsKeys = {
  IN_BYTES: localizedF("editors.policy.conditions.readSpeed"),
  OUT_BYTES: localizedF("editors.policy.conditions.writeSpeed"),
  IO_BYTES: localizedF("editors.policy.conditions.readWriteSpeed"),
}

export const unitBytesOptionsNapshotShize = {
  value: "GB",
  items: [
    { value: "MB", text: "Mega" },
    { value: "GB", text: "Giga" },
  ],
}

export const containOptions = {
  value: "CONTAINS",
  items: [
    { value: "CONTAINS", text: localizedF("editors.policy.conditions.Contains") },
    { value: "DOES_NOT_CONTAIN", text: localizedF("editors.policy.conditions.DoesntContain") },
  ],
}

export const includeOptions = {
  value: "ALL",
  items: [
    { value: "ALL", text: localizedF("general.all") },
    { value: "SOME", text: localizedF("general.Any") },
  ],
}

export const thresholdOptions = {
  value: 1,
  items: [
    { value: 1, text: "1" },
    { value: 2, text: "2" },
    { value: 3, text: "3" },
    { value: 4, text: "4" },
    { value: 5, text: "5" },
    { value: 6, text: "6" },
    { value: 7, text: "7" },
    { value: 8, text: "8" },
    { value: 9, text: "9" },
    { value: 10, text: "10" },
    { value: 11, text: "11" },
    { value: 12, text: "12" },
    { value: 13, text: "13" },
    { value: 14, text: "14" },
    { value: 15, text: "15" },
    { value: 16, text: "16" },
    { value: 17, text: "17" },
    { value: 18, text: "18" },
    { value: 19, text: "19" },
    { value: 20, text: "20" },
    { value: 21, text: "21" },
    { value: 22, text: "22" },
    { value: 23, text: "23" },
    { value: 24, text: "24" },
    { value: 25, text: "25" },
  ],
}

export const thresholdBytesOptions = {
  value: 1,
  items: [
    { value: 1, text: "1" },
    { value: 2, text: "2" },
    { value: 4, text: "4" },
    { value: 8, text: "8" },
    { value: 16, text: "16" },
    { value: 32, text: "32" },
    { value: 64, text: "64" },
    { value: 128, text: "128" },
    { value: 256, text: "256" },
    { value: 512, text: "512" },
  ],
}

export const daysOptions = {
  value: 1,
  items: [
    { value: 1, text: "1" },
    { value: 2, text: "2" },
    { value: 3, text: "3" },
    { value: 4, text: "4" },
    { value: 5, text: "5" },
    { value: 6, text: "6" },
    { value: 7, text: "7" },
    { value: 8, text: "8" },
    { value: 9, text: "9" },
    { value: 10, text: "10" },
    { value: 11, text: "11" },
    { value: 12, text: "12" },
    { value: 13, text: "13" },
    { value: 14, text: "14" },
    { value: 15, text: "15" },
    { value: 16, text: "16" },
    { value: 17, text: "17" },
    { value: 18, text: "18" },
    { value: 19, text: "19" },
    { value: 20, text: "20" },
    { value: 21, text: "21" },
    { value: 22, text: "22" },
    { value: 23, text: "23" },
    { value: 24, text: "24" },
    { value: 25, text: "25" },
    { value: 26, text: "26" },
    { value: 27, text: "27" },
    { value: 28, text: "28" },
    { value: 29, text: "29" },
    { value: 30, text: "30" },
    { value: 31, text: "31" },
  ],
}

export const everyUnitPicker = {
  value: "MINUTE",
  items: [
    { value: "MINUTE", text: localizedF("general.minutes") },
    { value: "HOUR", text: localizedF("general.hours") },
    { value: "DAY", text: localizedF("general.days") },
  ],
}

export const minuteHourUnitPicker = {
  value: "MINUTE",
  items: [
    { value: "MINUTE", text: localizedF("general.minutes") },
    { value: "HOUR", text: localizedF("general.hours") },
  ],
}

export const nameOptions = [
  { value: "FAN", label: localizedF("editors.policy.conditions.fanStatus") },
  { value: "BATTERY", label: localizedF("editors.policy.conditions.battery") },
  { value: "CHASSIS", label: localizedF("editors.policy.conditions.chassis") },
  { value: "STORAGE", label: localizedF("editors.policy.conditions.storage") },
  { value: "TEMPERATURE", label: localizedF("editors.policy.conditions.temperature") },
  { value: "POWER", label: localizedF("editors.policy.conditions.power") },
  { value: "WATCHDOG", label: localizedF("editors.policy.conditions.watchdog") },
  { value: "VOLTAGE", label: localizedF("editors.policy.conditions.voltage") },
  { value: "SYSTEM", label: localizedF("general.system") },
  { value: "SYSTEMBOARD", label: localizedF("editors.policy.conditions.systemBoard") },
  { value: "PROCESSORS", label: localizedF("general.processors") },
  { value: "PROCESSOR", label: localizedF("general.processor") },
  { value: "MEMORY", label: localizedF("general.memory") },
  { value: "MANAGEMENT_SUBSYSTEM_HEALTH", label: localizedF("editors.policy.conditions.managementSubsystemHealth") },
  { value: "CABLE_INTERCONNECT", label: localizedF("editors.policy.conditions.cableInterconnect") },
  { value: "OTHER", label: localizedF("general.other") },
]

export const stateOptions = [
  { value: "red", label: localizedF("editors.policy.conditions.red") },
  { value: "yellow", label: localizedF("editors.policy.conditions.yellow") },
  { value: "green", label: localizedF("editors.policy.conditions.green") },
  { value: "unknown", label: localizedF("editors.policy.conditions.unknown") },
]

export const modeOptions = [
  { value: "ON", label: localizedF("editors.policy.conditions.on") },
  { value: "OFF", label: localizedF("editors.policy.conditions.off") },
  { value: "SUSPENDED", label: localizedF("editors.policy.conditions.suspended") },
]

let nameKeysToObject = {}
let stateKeysToObject = {}
let modeKeysToObject = {}

forEach(option => {
  nameKeysToObject[option.value] = option
}, nameOptions)

forEach(option => {
  stateKeysToObject[option.value] = option
}, stateOptions)

forEach(option => {
  modeKeysToObject[option.value] = option
}, modeOptions)

export { nameKeysToObject, stateKeysToObject, modeKeysToObject }
